<template lang="pug">
v-card(light)
    v-card-text()
        chart(
            :options="pieChartOptions"
        )
</template>

<script lang="js">

import { Chart } from 'highcharts-vue';

export default {
    name: 'pieChart',
    components: {
        chart: Chart
    },
    props: {
        seriesData: {
            type: Array,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        spaceRemaining:{
            type: Number,
            required: true,
        }
    },
    data () {
        return {
            data:[],

        };
    },
    computed: {
        pieChartOptions (){
            return {
                credits: { enabled: false },
                chart: {
                    type: 'pie'
                },
                colors:[
                    '#00355c',
                    '#91b0e1'
                ],
                title: {
                    text: this.name,
                },
                tooltip: {
                    pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> ' +
                                '{point.name}</b><br/>' +
                                'Percentage: <b>{point.y}%</b><br/>' +
                                'Size on Disk: <b>{point.z}{point.g}</b><br/>'
                },
                subtitle: {
                    text: `${this.spaceRemaining}% Available`
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        showInLegend: true,
                        dataLabels: [{
                            enabled: true,
                            distance: 20
                        }, {
                            enabled: true,
                            distance: -40,
                            format: '{point.percentage:.1f}%',
                            style: {
                                fontSize: '1.2em',
                                textOutline: 'none',
                                opacity: 0.7
                            },
                            filter: {
                                operator: '>',
                                property: 'percentage',
                                value: 10
                            }
                        }]
                    }
                },
                series: [{
                    name: 'Percentage',
                    colorByPoint: true,
                    data: this.seriesData
                }]
            };
        }
    }

};
</script>
